var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Notification from "../../App/components/Notification";
import UsersService from "../services/UsersService";
import PhoneMaskInput from "../../App/components/PhoneInput";
import { useCustomer } from "../../App/hooks/useCustomer";
import { handleServiceError } from "../../App/components/ErrorHandler";
function EditManegament(props) {
    var _this = this;
    var navigate = useNavigate();
    var location = useLocation();
    var user = location.state.user;
    var _a = useState({
        password: "",
        password_confirmation: "",
        email: user.email,
        name: user.name,
        telephone: user.telephone,
        id: user.id,
        permissions: user.permissions
    }), formData = _a[0], setFormData = _a[1];
    var _b = useState(false), showPassword = _b[0], setShowPassword = _b[1];
    var _c = useState(false), showPassword2 = _c[0], setShowPassword2 = _c[1];
    var _d = useState(false), isPasswordValid = _d[0], setIsPasswordValid = _d[1];
    var _e = useState([
        { message: "Mínimo de 8 caracteres", isActive: false },
        { message: "Senha deve ter pelo menos um número.", isActive: false },
        {
            message: "Senha deve ter pelo menos uma letra maiúscula.",
            isActive: false,
        },
    ]), passwordError = _e[0], setPasswordError = _e[1];
    var _f = useState(false), isRequired = _f[0], setIsRequired = _f[1];
    var _g = useState([]), groupedPermissions = _g[0], setGroupedPermissions = _g[1];
    var customer = useCustomer().customer;
    var _h = useState([]), customerCampaing = _h[0], setCustomerCampaing = _h[1];
    useEffect(function () {
        getPermissions();
    }, []);
    useEffect(function () {
        if (customer.id) {
            getCustomerCampaingValidation(customer.id);
        }
    }, [customer.id]);
    function getPermissions() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UsersService.getPlatformPermissions().then(function (res) {
                            setGroupedPermissions(res.data.groupedPermissions);
                        }, function (err) {
                            if (err.response.status === 403) { }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function getCustomerCampaingValidation(customerId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, UsersService.getCustomerCampaingValidation(customerId).then(function (res) {
                            setCustomerCampaing(res.data.validCampings);
                        }, function (err) {
                            if (err.response.status === 403) { }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var handlePasswordChange = function (e) {
        var password = e.target.value;
        if (e.target.name === "newPassword") {
            setIsRequired(e.target.value.trim().length > 0);
        }
        setPasswordError(function (prevPasswordError) {
            return prevPasswordError.map(function (error) {
                switch (error.message) {
                    case "Mínimo de 8 caracteres":
                        return {
                            message: error.message,
                            isActive: password.length > 8,
                        };
                    case "Senha deve ter pelo menos um número.":
                        return {
                            message: error.message,
                            isActive: /\d/.test(password),
                        };
                    case "Senha deve ter pelo menos uma letra maiúscula.":
                        return {
                            message: error.message,
                            isActive: /[A-Z]/.test(password),
                        };
                    default:
                        return error;
                }
            });
        });
        setIsPasswordValid(password.length >= 8 &&
            /\d/.test(password) &&
            /[A-Z]/.test(password));
        setFormData(__assign(__assign({}, formData), { password: password }));
    };
    var handleConfirmPasswordChange = function (e) {
        if (e.target.name === "password_confirmation") {
            setIsRequired(e.target.value.trim().length > 0);
        }
        var errorMessage = "";
        if (formData.password !== formData.password_confirmation) {
            errorMessage = "As senhas não correspondem.";
            setPasswordError([{ message: errorMessage, isActive: true }]);
        }
        setFormData(__assign(__assign({}, formData), { password_confirmation: e.target.value }));
    };
    var handleEmailChange = function (e) {
        setFormData(__assign(__assign({}, formData), { email: e.target.value }));
    };
    var handleNameChange = function (e) {
        setFormData(__assign(__assign({}, formData), { name: e.target.value }));
    };
    var handleTelephoneChange = function (e) {
        setFormData(__assign(__assign({}, formData), { telephone: e.target.value }));
    };
    var handleShowPasswordClick = function (passwordType) {
        switch (passwordType) {
            case "new":
                setShowPassword(!showPassword);
                break;
            case "confirm":
                setShowPassword2(!showPassword2);
                break;
            default:
                break;
        }
    };
    var userHasPermission = function (permissionId) {
        return formData.permissions.includes(permissionId);
    };
    var handlePermissionChange = function (e) {
        var permissions = formData.permissions;
        if (permissions.find(function (id) { return (id === Number(e.target.value)); }) === undefined) {
            permissions.push(Number(e.target.value));
            setFormData(__assign(__assign({}, formData), { permissions: permissions }));
        }
        else {
            permissions = permissions.filter(function (id) { return (id !== Number(e.target.value)); });
            setFormData(__assign(__assign({}, formData), { permissions: permissions }));
        }
    };
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    request = {
                        name: formData.name,
                        email: formData.email,
                        telephone: formData.telephone,
                        permissions: formData.permissions
                    };
                    if (formData.password) {
                        request.password = formData.password;
                        request.password_confirmation = formData.password_confirmation;
                    }
                    Notification().Loading.dots("Salvando alterações");
                    return [4 /*yield*/, UsersService.update(user.id, request).then(function (res) {
                            Notification().Loading.remove();
                            Notification().Notify.success(res.data.success);
                            navigate(-1);
                        }, function (err) {
                            Notification().Loading.remove();
                            handleServiceError(err);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "content-internal-padding" }, { children: [_jsx("div", __assign({ className: "border-bottom mb-4" }, { children: _jsx("h3", __assign({ style: { paddingLeft: "0" } }, { children: "Alterar dados de acesso" })) })), _jsxs("form", __assign({ autoComplete: "off", onSubmit: handleSubmit, style: { width: "100%" } }, { children: [_jsx("div", __assign({ className: "row" }, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "card pb-5" }, { children: [_jsxs("div", __assign({ style: { padding: "3rem 3rem 0rem 3rem" } }, { children: [_jsx("h5", { children: "Administrador" }), _jsx("hr", { style: { marginBottom: "0px", width: "93%" } }), _jsx("label", __assign({ htmlFor: "userName", style: { marginTop: "1rem" } }, { children: "Nome de usu\u00E1rio:" })), _jsx("div", { children: _jsx("input", { className: "input-password", id: "userName", name: "userName", onChange: handleNameChange, type: "text", defaultValue: user.name }) })] })), _jsxs("div", __assign({ style: { padding: "1rem 3rem 0rem 3rem" } }, { children: [_jsx("label", __assign({ htmlFor: "userEmail", style: { marginTop: "1rem" } }, { children: "E-mail de acesso:" })), _jsx("div", { children: _jsx("input", { className: "input-password", id: "userEmail", name: "userEmail", onChange: handleEmailChange, defaultValue: user.email, type: "email" }) })] })), _jsx("div", __assign({ style: { padding: "1rem 3rem 0rem 3rem" } }, { children: _jsx(PhoneMaskInput, { userphone: user.telephone, onChange: handleTelephoneChange }) })), _jsxs("div", __assign({ style: { padding: "3rem 3rem 0rem 3rem", marginTop: "1rem" } }, { children: [_jsx("h5", { children: "Senha" }), _jsx("hr", { style: { marginBottom: "0px", width: "94%" } }), _jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "newPassword", style: { marginTop: "1rem" } }, { children: "Nova senha:" })), _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("input", { type: showPassword ? "text" : "password", className: "input-password", id: "newPassword", name: "newPassword", value: formData.password, onChange: handlePasswordChange, autoComplete: "new-password", required: isRequired }), _jsx("button", __assign({ type: "button", onClick: function () { return handleShowPasswordClick("new"); }, className: "button-eye", style: { marginTop: "0.5em" } }, { children: showPassword ? (_jsx(VisibilityOffIcon, {})) : (_jsx(VisibilityIcon, {})) }))] })), _jsxs("div", { children: [_jsx("label", __assign({ htmlFor: "confirmPassword", style: { marginTop: "1rem" } }, { children: "Confirmar nova senha:" })), _jsxs("div", __assign({ className: "d-flex" }, { children: [_jsx("input", { type: showPassword2 ? "text" : "password", className: "input-password", id: "confirmPassword", name: "password_confirmation", value: formData.password_confirmation, onChange: handleConfirmPasswordChange, required: isRequired }), _jsx("button", __assign({ type: "button", onClick: function () { return handleShowPasswordClick("confirm"); }, className: "button-eye", style: { marginTop: "0.5em" } }, { children: showPassword2 ? (_jsx(VisibilityOffIcon, {})) : (_jsx(VisibilityIcon, {})) }))] })), passwordError && (_jsx("div", __assign({ className: "mt-2" }, { children: passwordError.map(function (error, index) {
                                                                    if ((error.message ===
                                                                        "Mínimo de 8 caracteres" &&
                                                                        formData
                                                                            .password
                                                                            .length >=
                                                                            8) ||
                                                                        (error.message ===
                                                                            "Senha deve ter pelo menos um número." &&
                                                                            /\d/.test(formData.password)) ||
                                                                        (error.message ===
                                                                            "Senha deve ter pelo menos uma letra maiúscula." &&
                                                                            /[A-Z]/.test(formData.password))) {
                                                                        return (_jsx("p", __assign({ className: "password-error ".concat(error.isActive
                                                                                ? "green-message"
                                                                                : "red-message") }, { children: error.message }), index));
                                                                    }
                                                                    else if (formData.password !==
                                                                        formData.password_confirmation) {
                                                                        return (_jsx("p", __assign({ className: "password-error red-message" }, { children: "As senhas n\u00E3o correspondem." }), index));
                                                                    }
                                                                    return null;
                                                                }) })))] })] })] }))] })) }) })), _jsx("div", __assign({ className: "row mt-4" }, { children: _jsx("div", __assign({ className: "col" }, { children: _jsx("div", __assign({ className: "card" }, { children: _jsxs("div", __assign({ className: "card-body", style: { padding: "3rem 3rem 0rem" } }, { children: [_jsx("h5", { children: "Permiss\u00F5es" }), _jsx("hr", { style: { marginBottom: "0px", width: "93%" } }), _jsx("div", __assign({ className: "row p-2" }, { children: groupedPermissions.length > 0 ?
                                                (groupedPermissions
                                                    .filter(function (groupedPermissions) { return customerCampaing.length > 0 || groupedPermissions.group !== "Campanha"; })
                                                    .map(function (groupedPermission, index) { return (_jsxs("div", __assign({ className: "col-6 p-3" }, { children: [_jsx("h5", { children: groupedPermission.group }), groupedPermission.permissions.map(function (permission) { return (_jsxs("div", __assign({ className: "form-check" }, { children: [_jsx("input", { className: "form-check-input", type: "checkbox", value: permission.id, name: "permissionsId", onChange: handlePermissionChange, checked: userHasPermission(permission.id) }), _jsx("label", __assign({ className: "form-check-label" }, { children: permission.label }))] }), permission.code)); })] }), index)); })) :
                                                (_jsx("p", { children: "Nenhuma permiss\u00E3o encontrada" })) }))] })) })) })) })), _jsxs("div", __assign({ className: "d-flex justify-content-evenly mt-4 mb-4", style: { width: "90%", marginLeft: "1.5rem" } }, { children: [_jsx("button", __assign({ className: "btn btn-super", type: "submit", style: { width: "45%", } }, { children: "Confirmar" })), _jsx("button", __assign({ className: "btn btn-super-blue", style: { width: "45%" }, onClick: function (event) { event.preventDefault(); navigate(-1); } }, { children: "Cancelar" }))] }))] }))] })));
}
export default EditManegament;
